export enum IrbOrdersEvents {
    SHOW_CREATE_BLOCKS_DIALOG = "IRBORDERSEVENTS.SHOW_CREATE_BLOCKS_DIALOG",
    SHOW_UNBLOCK_ORDERS_DIALOG = "IRBORDERSEVENTS.SHOW_UNBLOCK_ORDERS_DIALOG",
    SHOW_IMPORT_ORDERS="IRBORDERSEVENTS.SHOW_IMPORT_ORDERS",
    SHOW_IMPORT_ORDERS_RESULT="IRBORDERSEVENTS.SHOW_IMPORT_ORDERS_RESULT",
    SHOW_QUICK_ORDER_ENTRY="IRBORDERSEVENTS.SHOW_QUICK_ORDER_ENTRY"
}
